<template>
  <div class="analysis">
    <div class="a-header" :style="showItem ? '' : 'border-radius:5px'">
      <div class="a-h-left" @click="changeShowItem(!showItem)">
        <span :class="['a-h-l-icon', showItem ? 'a-h-l-showIcon' : '']"></span>
        <span class="a-h-l-title" v-if="!editTitle">{{ title }}</span>
        <div class="a_h_l_t_input" v-if="editTitle" @click.stop="() => {}">
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
            @submit.native.prevent
          >
            <el-form-item prop="name">
              <el-input
                v-model="form.name"
                @blur="editNameCheckFn()"
                @keyup.enter.native="editNameCheckFn"
                ref="editNameInputRef"
                placeholder="请输入新的名称"
              ></el-input>
            </el-form-item>
            <!--   @blur="editNameCheckFn()" -->
          </el-form>
        </div>
        <el-tooltip
          v-if="!editTitle"
          class="item"
          effect="light"
          content="修改名称"
          placement="top"
        >
          <span class="a_h_l_edit" @click.stop="editTitleFn()">
            <img
              src="../../../../assets/icon/classroomObservation/editIcon2.svg"
            /> </span
          >>
        </el-tooltip>
      </div>
      <div class="a-h-right">
        <!-- <el-popover placement="bottom-end" width="150" v-model="visible" trigger="manual">
          <div class="a_h_r_boxList" v-click-outside="()=>visible = false">
					</div> -->
        <div
          class="a_h_r_more"
          slot="reference"
          v-if="!isDrag"
          @click.stop="visible = !visible"
        >
          <img src="@/assets/icon/classroomObservation/moreIcon.svg" alt="" />
        </div>

        <div class="a_h_r_scBtn" v-if="isDrag">
          <span class="a_h_r_cancel" @click.stop="dragCancel()">取消</span>
          <span class="a_h_r_submit" @click.stop="dragSubmit()">完成</span>
        </div>

        <div
          class="a_h_r_boxList"
          v-if="visible"
          v-click-outside="() => (visible = false)"
        >
          <div @click="addTemplate">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.00003 4C2.00003 3.72386 2.22389 3.5 2.50003 3.5H4C4.27614 3.5 4.5 3.72386 4.5 4C4.5 4.27614 4.27614 4.5 4 4.5H3.00003L3 14H11V11C11 10.7239 11.2239 10.5 11.5 10.5C11.7762 10.5 12 10.7239 12 11V14.5C12 14.7761 11.7762 15 11.5 15H2.5C2.36739 15 2.24021 14.9473 2.14645 14.8536C2.05268 14.7598 2 14.6326 2 14.5L2.00003 4Z"
                fill="black"
                fill-opacity="0.9"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 5.5C5 5.22386 5.22386 5 5.5 5H13.5C13.7761 5 14 5.22386 14 5.5C14 5.77614 13.7761 6 13.5 6H5.5C5.22386 6 5 5.77614 5 5.5Z"
                fill="black"
                fill-opacity="0.9"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.5 1C9.77614 1 10 1.22386 10 1.5V9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5V1.5C9 1.22386 9.22386 1 9.5 1Z"
                fill="black"
                fill-opacity="0.9"
              />
            </svg>

            添加模块
          </div>
          <div @click="moveAnalysis()" v-if="tid">
            <svg
              t="1727591669869"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4289"
              width="200"
              height="200"
            >
              <path
                d="M514.64 511m-84.76 0a84.76 84.76 0 1 0 169.52 0 84.76 84.76 0 1 0-169.52 0Z"
                fill="#000000"
                p-id="4290"
              ></path>
              <path
                d="M661.36 190.85L548.54 78a47.85 47.85 0 0 0-32-14c-1.21-0.09-2.43-0.15-3.66-0.15A48.95 48.95 0 0 0 478.58 78L365.77 190.85a48 48 0 0 0 0 67.88 48 48 0 0 0 67.88 0l31.21-31.21v115.22a48 48 0 0 0 48 48 48 48 0 0 0 48-48V226.11l32.61 32.62a48 48 0 0 0 67.89 0 48 48 0 0 0 0-67.88zM364.23 832.86l112.82 112.81a47.82 47.82 0 0 0 32 14c1.21 0.09 2.43 0.15 3.66 0.15A48.9 48.9 0 0 0 547 945.67l112.83-112.81a48 48 0 0 0 0-67.88 48 48 0 0 0-67.89 0l-31.21 31.2V681a48 48 0 0 0-48-48 48 48 0 0 0-48 48v116.59L432.12 765a48 48 0 0 0-67.89 0 48 48 0 0 0 0 67.86zM831.12 663.76L943.93 551a47.86 47.86 0 0 0 14-32c0.09-1.21 0.15-2.43 0.15-3.67A48.86 48.86 0 0 0 943.93 481L831.12 368.17a48 48 0 0 0-67.89 0 48 48 0 0 0 0 67.88l31.21 31.21H679.23a48 48 0 0 0-48 48 48 48 0 0 0 48 48h116.62l-32.62 32.62a48 48 0 0 0 0 67.88 48 48 0 0 0 67.89 0zM187.88 366.64L75.06 479.45a47.82 47.82 0 0 0-14 32c-0.1 1.21-0.16 2.43-0.16 3.67a48.86 48.86 0 0 0 14.17 34.27l112.81 112.84a48 48 0 0 0 67.88 0 48 48 0 0 0 0-67.88l-31.21-31.21h115.21a48 48 0 0 0 48-48 48 48 0 0 0-48-48H223.14l32.62-32.62a48 48 0 0 0 0-67.88 48 48 0 0 0-67.88 0z"
                fill="#000000"
                p-id="4291"
              ></path>
            </svg>
            移动模块
          </div>
          <div @click="addNewAnalysisGroup(0)">
            <svg
              t="1727073223211"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3257"
              width="200"
              height="200"
            >
              <path
                d="M546.901333 314.282667a46.805333 46.805333 0 0 0-69.802666 0l-296.021334 340.736c-24.32 28.032-3.328 70.314667 34.944 70.314666h591.957334c38.272 0 59.306667-42.282667 34.944-70.314666l-296.021334-340.736z"
                p-id="3258"
              ></path></svg
            >添加分析
          </div>
          <div @click="addNewAnalysisGroup(1)">
            <svg
              style="transform: rotate(180deg);"
              t="1727073223211"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3257"
              width="200"
              height="200"
            >
              <path
                d="M546.901333 314.282667a46.805333 46.805333 0 0 0-69.802666 0l-296.021334 340.736c-24.32 28.032-3.328 70.314667 34.944 70.314666h591.957334c38.272 0 59.306667-42.282667 34.944-70.314666l-296.021334-340.736z"
                p-id="3258"
              ></path></svg
            >添加分析
          </div>

          <div @click="setTheLocation(0)" v-if="![0].includes(index)">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1551_2752)">
                <path
                  d="M11 7.5L8 4L5 7.5H7.47826V13.5C7.47826 13.7761 7.71185 14 8 14C8.28815 14 8.52174 13.7761 8.52174 13.5V7.5H11Z"
                  fill="black"
                  fill-opacity="0.9"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2 3L14 3V2L2 2L2 3Z"
                  fill="black"
                  fill-opacity="0.9"
                />
              </g>
              <defs>
                <clipPath id="clip0_1551_2752">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            置顶
          </div>
          <div @click="setTheLocation(1)" v-if="![maxIndex].includes(index)">
            <svg
              width="16"
              height="16"
              style="transform: rotate(180deg);"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1551_2752)">
                <path
                  d="M11 7.5L8 4L5 7.5H7.47826V13.5C7.47826 13.7761 7.71185 14 8 14C8.28815 14 8.52174 13.7761 8.52174 13.5V7.5H11Z"
                  fill="black"
                  fill-opacity="0.9"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2 3L14 3V2L2 2L2 3Z"
                  fill="black"
                  fill-opacity="0.9"
                />
              </g>
              <defs>
                <clipPath id="clip0_1551_2752">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            置底
          </div>

          <div @click="setTheLocation(2)" v-if="![0].includes(index)">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1552_2795)">
                <path
                  d="M11 5.5L8 2L5 5.5H7.47826V13.5C7.47826 13.7761 7.71185 14 8 14C8.28815 14 8.52174 13.7761 8.52174 13.5V5.5H11Z"
                  fill="black"
                  fill-opacity="0.9"
                />
              </g>
              <defs>
                <clipPath id="clip0_1552_2795">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            上移
          </div>

          <div @click="setTheLocation(3)" v-if="![maxIndex].includes(index)">
            <svg
              style="transform: rotate(180deg);"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1552_2795)">
                <path
                  d="M11 5.5L8 2L5 5.5H7.47826V13.5C7.47826 13.7761 7.71185 14 8 14C8.28815 14 8.52174 13.7761 8.52174 13.5V5.5H11Z"
                  fill="black"
                  fill-opacity="0.9"
                />
              </g>
              <defs>
                <clipPath id="clip0_1552_2795">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            下移
          </div>

          <div @click="deleteAnalysisGroup()" v-if="maxIndex !== 0">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.25 3.125C6.25 2.77982 6.52982 2.5 6.875 2.5H13.125C13.4702 2.5 13.75 2.77982 13.75 3.125C13.75 3.47018 13.4702 3.75 13.125 3.75H6.875C6.52982 3.75 6.25 3.47018 6.25 3.125Z"
                fill="black"
                fill-opacity="0.6"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.5 5.625C2.5 5.26481 2.77982 5 3.125 5H16.875C17.2202 5 17.5 5.26481 17.5 5.625C17.5 6.03952 17.2202 6.25 16.875 6.25L15.625 6.30435V17.5H4.375V6.25H3.125C2.77982 6.25 2.5 6.03952 2.5 5.625ZM5.625 6.25V16.1957L14.375 16.25V6.30435L5.625 6.25Z"
                fill="black"
                fill-opacity="0.6"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.125 8.06838C8.47018 8.06838 8.75 8.32276 8.75 8.63656V13.7502C8.75 14.064 8.47018 14.3184 8.125 14.3184C7.77982 14.3184 7.5 14.064 7.5 13.7502V8.63656C7.5 8.32276 7.77982 8.06838 8.125 8.06838Z"
                fill="black"
                fill-opacity="0.6"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.875 8.06838C12.2202 8.06838 12.5 8.32276 12.5 8.63656V13.7502C12.5 14.064 12.2202 14.3184 11.875 14.3184C11.5298 14.3184 11.25 14.064 11.25 13.7502V8.63656C11.25 8.32276 11.5298 8.06838 11.875 8.06838Z"
                fill="black"
                fill-opacity="0.6"
              />
            </svg>
            删除分析
          </div>
        </div>
        <!-- </el-popover> -->
        <!-- <div class="a-h-r-btn" @click.stop="addTemplate">
          <img src="@/assets/icon/classroomObservation/newcon.svg" alt="" />
          添加模块
        </div> -->
      </div>
    </div>
    <div class="a-main" v-show="showItem || isDrag">
      <template v-for="(item, index) in analysisItemList">
        <div
          class="a_m_dragBox"
          ref="dragBoxRefTop"
          :type="`${type}_${index}_${item.tIndex}_0`"
          v-if="isDrag && index === 0"
        ></div>
        <analysisItem
          ref="analysisItemRef"
          v-if="
            ![
              converter('S-T分析：课堂时间分配'),
              converter('S-T分析：师生互动分析'),
              converter('S-T分析：教学模式分析')
            ].includes(converter(item.jsonData.name)) &&
              !['bfe844b1-7a45-11ef-9b30-005056b86db5'].includes(
                item.jsonData.mId
              )
          "
          :dialogTagDataList="dialogTagDataList"
          :dataList="dataList"
          :bmData="bmData"
          :key="item.id + item.Type + '-' + index"
          :data="item"
          :tid="tid"
          :dialogTagList="dialogTagList"
          :fileId="fileId"
          :index="index"
          :showBrief="showBrief"
          :isDrag="isDrag"
          @delItem="delItem"
          @editItem="editItem"
          @saveItem="saveItem"
          @moveAnalysis="moveAnalysisSubmit"
        />
        <analysisSpecialItem
          v-if="
            [
              converter('S-T分析：课堂时间分配'),
              converter('S-T分析：师生互动分析'),
              converter('S-T分析：教学模式分析')
            ].includes(converter(item.jsonData.name)) ||
              ['bfe844b1-7a45-11ef-9b30-005056b86db5'].includes(
                item.jsonData.mId
              )
          "
          :dialogTagDataList="dialogTagDataList"
          ref="analysisItemRef"
          :bmData="bmData"
          :key="item.id + item.Type + '-' + index"
          :data="item"
          :tid="tid"
          :dialogTagList="dialogTagList"
          :fileId="fileId"
          :index="index"
          :isDrag="isDrag"
          :showBrief="showBrief"
          @delItem="delItem"
          @editItem="editItem"
          @saveItem="saveItem"
          @moveAnalysis="moveAnalysisSubmit"
        />
        <div
          class="a_m_dragBox"
          ref="dragBoxRefBottom"
          :type="`${type}_${index}_${item.tIndex}_1`"
          v-if="isDrag"
        ></div>
      </template>
      <div class="a_m_empty" v-if="analysisItemList.length == 0">
        <span v-if="!isDrag">暂无模块...</span>
        <div
          class="a_m_dragBox"
          ref="dragBoxRefBottom"
          :type="`${type}_0_0_2`"
          v-if="isDrag"
        ></div>
      </div>
    </div>
    <editNameDialog ref="editNameDialogRef" @success="editNameSuccess" />
  </div>
</template>

<script>
import analysisItem from "./analysisItem";
import analysisSpecialItem from "./analysisSpecialItem";
import editNameDialog from "./editNameDialog.vue";
var OpenCC = require("opencc-js");
let converter2 = OpenCC.Converter({
  from: "hk",
  to: "cn"
});

// 自定义指令，用于处理点击外部区域的事件
const clickOutside = {
  bind(el, binding) {
    // 在元素上绑定一个点击事件监听器
    el.clickOutsideEvent = function(event) {
      // 检查点击事件是否发生在元素的内部
      if (!(el === event.target || el.contains(event.target))) {
        // 如果点击事件发生在元素的外部，则触发指令绑定的方法,将点击的event数据传过去
        binding.value(event);
      }
    };
    // 在文档上添加点击事件监听器
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unbind(el) {
    // 在元素上解除点击事件监听器
    document.removeEventListener("click", el.clickOutsideEvent);
  }
};

export default {
  emits: ["delItem", "editItem", "saveItem"],
  directives: {
    "click-outside": clickOutside // 注册自定义指令
  },
  props: {
    bmData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    title: {
      type: String,
      default: "分析"
    },
    showBrief: {
      type: Boolean,
      default: true
    },
    dialogTagDataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    analysisItemList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    type: {
      type: Number,
      default: 0
    },
    tid: {
      type: String,
      require: true
    },
    fileId: {
      type: String,
      require: true
    },
    dataList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    index: {
      type: Number,
      default: 0
    },
    maxIndex: {
      type: Number,
      default: 0
    },
    isDrag: {
      type: Boolean,
      default: false
    },
    dialogTagList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  components: {
    analysisItem,
    analysisSpecialItem,
    editNameDialog
  },
  computed: {
    converter() {
      return function(word) {
        return converter2(word);
      };
    }
  },
  data() {
    return {
      showDialog: false,
      showItem: true,
      visible: false,
      form: {
        name: ""
      },
      editTitle: false,
      rules: {
        name: [
          { required: true, trigger: "change", message: "请输入新的名称" },
          {
            min: 1,
            max: 20,
            trigger: "change",
            message: "长度需在1-20个字符之间"
          }
        ]
      }
    };
  },
  methods: {
    addTemplate() {
      if (!this.tid) return this.$message.error("请新建课堂，或选择历史课堂");
      this.visible = false;
      this.$emit("updateMessage", this.type);
    },
    changeShowItem(newValue) {
      this.showItem = newValue;
    },
    delItem(id) {
      this.$emit("delItem", id);
    },
    editItem(id, _data) {
      this.$emit("editItem", id, _data);
    },
    saveItem(id, _data) {
      this.$emit("saveItem", id, _data);
    },
    getReport(id) {
      if (!id) {
        this.$nextTick(() => {
          if (this.$refs.analysisItemRef) {
            this.$refs.analysisItemRef.forEach(i => {
              i.editBtn(false);
            });
          }
        });
      } else {
        this.$nextTick(() => {
          this.$refs.analysisItemRef[
            this.analysisItemList.findIndex(i => i.id == id)
          ].editBtn(false);
        });
      }
    },
    editTitleFn() {
      if (!this.tid) return this.$message.info("请新建课堂，或选择历史课堂");
      this.form.name = this.title;
      this.editTitle = true;
      this.$nextTick(() => {
        this.$refs.editNameInputRef.focus();
      });
      // this.$refs.editNameDialogRef.open(this.title)
    },
    editNameCheckFn() {
      if (!this.editTitle) return;
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.editTitle = false;
          this.editNameSuccess(this.form.name);
        } else {
          this.$nextTick(() => {
            this.$refs.editNameInputRef.focus();
            this.$message.error("该名称不符合规则");
          });
        }
      });
    },
    editNameSuccess(name) {
      this.$emit("changeAnalysisName", { name: name, type: this.type });
      // this.$refs.editNameDialogRef.close()
    },
    addNewAnalysisGroup(po = 1) {
      //0：上面   1：下面
      if (!this.tid) return this.$message.error("请新建课堂，或选择历史课堂");
      this.visible = false;
      this.$confirm("确定添加新的分析分组吗？", "添加分析", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring"
      })
        .then(() => {
          this.$emit("addNewAnalysisGroup", { type: this.type, po: po });
        })
        .catch(() => {});
    },
    deleteAnalysisGroup() {
      if (!this.tid) return this.$message.error("请新建课堂，或选择历史课堂");
      this.visible = false;
      this.$confirm("删除后无法恢复，确定删除该分析吗？", "删除分析", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring"
      })
        .then(res => {
          let _groupId = this.analysisItemList.map(i => i.id);
          this.$emit("delAnalysisGroup", {
            type: this.type,
            groupId: _groupId
          });
        })
        .catch(e => {});
    },
    setTheLocation(type = 0) {
      this.visible = false;
      if (!this.tid) return this.$message.error("请新建课堂，或选择历史课堂");
      this.$emit("setTheLocation", { value: this.type, type: type });
    },
    moveAnalysis() {
      this.visible = false;
      this.$parent.isDrag = true;
    },
    dragSubmit() {
      this.visible = false;
      this.$parent.moveAnalysisSubmit();
    },
    moveAnalysisSubmit(data) {
      this.$emit("moveAnalysis", data);
    },
    dragCancel() {
      this.$parent.moveAnalysisCancel();
    }
  }
};
</script>

<style scoped>
.itemTit {
  width: 136px;
  height: 32px;
  padding: 5px 8px 5px 8px;
  gap: 8px;
  opacity: 0px;
  margin: 20px 0;
  margin-bottom: 10px;
  border-bottom: 1px #ccc solid;
}
.analysis {
  width: 100%;
  height: auto;
  margin-top: 20px;
}

.a-header {
  width: calc(100% - 10px);
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 10px;
  background-color: #f8f9fa;
  border-radius: 5px 5px 0 0;
}

.a-h-left {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1;
  height: 100%;
}

.a-h-l-icon {
  width: 18px;
  height: 18px;
  background: url("../../../../assets/icon/classroomObservation/right.svg")
    no-repeat;
  background-size: 100% 100%;
  margin-right: 5px;
  transition: 0.3s;
}

.a-h-l-showIcon {
  transform: rotate(90deg);
}

.a-h-l-title {
  font-size: 18px;
  font-weight: bold;
}

.a-h-r-btn {
  font-size: 16px;
  height: 35px;
  width: auto;
  box-sizing: border-box;
  /* padding: 0 20px; */
  /* border: solid 1px #C5C5C5; */
  /* border-radius: 18px; */
  cursor: pointer;
  /* background-color: white; */
  display: flex;
  color: rgba(54, 129, 252, 1);
  justify-content: center;
  align-items: center;
}

.a-h-r-btn > img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.a-main {
  width: calc(100% - 10px - 30px);
  height: auto;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  padding: 15px;
}

.a-dialog {
  position: fixed;
  width: 1200px;
  height: 500px;
  min-height: 600px;
  box-shadow: 0px 0 8px 0px #555555;
  border-radius: 8px;
  z-index: 999;
  background-color: #fff;
  left: 0;
  right: 0;
  top: 100px;
  margin: 0 auto;
  /* margin: 0 auto; */
  /* top: 50%; */
  /* margin: -18% 0 0 -300px; */
  overflow: hidden;
}

.a-d-top {
  /* background: #adadad; */
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 54px;
  border-radius: 8px 8px 0 0;
  user-select: none;
  border-bottom: 1px #ccc solid;
}
.a-d-top >>> .el-input__inner {
  width: 320px;
  height: 32px;
}
.a-d-top >>> .el-input__icon {
  line-height: 32px;
}
.a-d-topTit {
  width: 171px;
  height: 32px;
  display: flex;
  align-items: center;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  line-height: 22px;
  justify-content: center;
  /* text-align: left; */
}
.a-d-t-left {
  width: 200px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-left: 5px;
}

.a-d-t-l-item {
  /* width: auto;
	height: 90%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 10px;
	border-radius: 10px;
	background-color: #d4d9da;
	margin-right: 3px;
	cursor: pointer; */
  cursor: pointer;
  width: 136px;
  height: 32px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-family: PingFang SC;
  box-sizing: border-box;
  padding: 5px;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  margin-bottom: 20px;
}

.a-d-t-l-item:hover {
  background-color: white;
}

.a-d-t-right {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black !important;
}

.a-d-t-right > span {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* align-items: center; */
  font-size: 22px;
  color: #fff;
  /* background-color: #adadad; */
  cursor: pointer;
  /* background-color: #e6e6e6; */
  color: #adadad;
}

.a-d-box {
  width: 100%;
  height: 100%;
  /* height: calc(100% - 40px); */
  background-color: #f0f2f5;
  overflow: auto;

  box-sizing: border-box;
  padding: 15px;
  padding-bottom: 50px;
}

.a-d-b-item {
  width: 22%;
  height: 200px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  padding: 15px;
  float: left;
  box-sizing: border-box;
  margin-bottom: 10px;
  /* position: relative; */
}
.a-d-b-item:hover .a-d-b-i-bottomBtn {
  display: block !important;
}
.a-d-b-item:hover .a-d-b-i-bottomPer {
  display: none !important;
}
.a-d-b-i-top {
  width: 100%;
  /* height: 50%; */
  height: 20px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.a-d-b-i-top > img {
  width: 35px;
  height: 35px;
}
/* .a-d-b-i-top>div{ */
/* width: auto;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: 10px; */
/* } */

.a-d-b-i-t-title {
  width: 100%;
  height: 35px;
  display: block;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  line-height: 35px;
  /* display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	overflow: hidden; */
}

.a-d-b-i-bottom {
  width: 100%;
  flex: 1;
  overflow: hidden;
  /* max-height: 186px; */
  font-size: 14px;
  -webkit-line-clamp: 5;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.a-d-b-i-t-btn {
  font-size: 14px;
  /* height: 30px; */
  /* position: relative; */
  /* top: 5px; */
  box-sizing: border-box;
  padding: 8px 25px;
  /* background-color: #f3f3f3; */
  border: 1px solid rgba(54, 129, 252, 1);
  border-radius: 5px;
  color: rgba(54, 129, 252, 1);

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /* position: absolute; */
  /* right: 10px; */
  /* top: 10px; */
}
.a-d-b-i-t-btn1 {
  font-size: 14px;
  box-sizing: border-box;
  padding: 8px 25px;
  border: 1px solid rgba(54, 129, 252, 1);
  border-radius: 5px;
  background-color: rgba(54, 129, 252, 1);
  display: flex;
  color: #fff;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.a_m_empty {
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 14px;
  color: #555555;
}

.a_h_r_more {
  margin-right: 10px;
  width: 35px;
  height: 35px;
}

.a_h_r_more > img {
  width: 35px;
  height: 35px;
  cursor: pointer;
}

.a_h_r_boxList {
  width: auto;
  height: auto;
  position: absolute;
  top: calc(100% - 10px);
  right: 0;
  border: 1px solid #e7e7e7;
  box-shadow: 0px 8px 10px -5px #00000014;

  box-shadow: 0px 16px 24px 2px #0000000a;

  box-shadow: 0px 6px 30px 5px #0000000d;
  border-radius: 8px;
  background-color: #fff;
  padding: 10px;
  z-index: 10;
}

.a_h_r_boxList > div {
  width: auto;
  white-space: nowrap;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px;
  transition: 0.3s;
  cursor: pointer;
}

.a_h_r_boxList > div:hover {
  background-color: #f0f2f5;
}

.a_h_r_boxList > div > svg {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.a-h-right {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

.a_h_l_edit {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.a_h_l_edit > img {
  width: 100%;
  height: 100%;
}
.a_h_l_t_input {
  width: 25%;
  min-width: 220px;
  height: 100%;
  display: flex;
  align-items: center;
}

.a_h_l_t_input >>> .el-form {
  width: 100%;
  min-width: 220px;
}

.a_h_l_t_input >>> .el-form-item {
  margin-bottom: 0;
}

.a_m_dragBox {
  width: 100%;
  height: 40px;
  border-radius: 3px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border: 1px dashed rgba(54, 129, 252, 1);
  background-color: #f8f9fa;
  transition: 0.3s;
  cursor: pointer;
}

.a_h_r_scBtn {
  height: 100%;
  padding: 0 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.a_h_r_scBtn > .a_h_r_submit {
  padding: 5px 10px;
  background-color: rgba(54, 129, 252, 1);
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.a_h_r_submit > a_h_r_submit:hover {
  background-color: rgb(19, 106, 247);
}

.a_h_r_scBtn > .a_h_r_cancel {
  padding: 5px 10px;
  background-color: #fff;
  border-radius: 3px;
  color: black;
  cursor: pointer;
  border: solid 1px #e7e7e7;
  font-size: 14px;
  margin-right: 10px;
}

.a_h_r_submit > .a_h_r_cancel:hover {
  background-color: #e0d9d9;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/analysis.vue